(function () {
  function setNavbarHeight() {
    var header = document.querySelector('.photodudebut .section-header') || document.querySelector('.photodudebut');
    if (!header) return;
    var height = header.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty('--navbar-height', height + 'px');
    }
  }

  setNavbarHeight();
  window.addEventListener('load', setNavbarHeight);
  window.addEventListener('resize', setNavbarHeight);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setNavbarHeight);
  }
})();
